import { HotelImage } from "./HotelImage"
import PlayCircleOutline from "@mui/icons-material/PlayCircleOutline"
import { lineLink } from "./App"
import type { Room } from "./rooms"
import { text } from "./text"
export function RoomCard(data: Room) {
  return (
    <div className="min-w-0 w-full max-w-sm mx-auto text-olive text-center">
      <div className="flex h-full flex-col shadow-lg bg-soft-primary rounded-2xl overflow-hidden">
        <HotelImage sizes="(min-width: 976px) 33vw, (min-width: 768px) 50vw, 100vw" className="aspect-[3/2] w-full shrink-0 object-cover rounded-t-lg" src={data.image} alt={data.roomTypeName.en} />
        <div className="flex-1 px-5 py-7 sm:px-6 sm:py-8">
          <h5 className="text-olive text-3xl font-medium leading-tight mb-4">
            {text(data.roomTypeName)}
          </h5>
          <div className="text-center text-muted leading-relaxed">{text(data.description)}</div>
        </div>
        <div className="grid grid-cols-[1.8fr_1fr] min-h-[88px] bg-primary">
          <p className="flex items-center justify-center px-3 py-5 text-olive text-4xl leading-none whitespace-nowrap">
            {data.price.toLocaleString()} ฿
          </p>
          <div className="border-l-2 border-soft-primary text-olive">
            <a
              target="_blank" rel="noopener noreferrer"
              href={data.videoLink}
              className="flex h-full min-h-[88px] w-full items-center justify-center transition-colors hover:bg-soft-primary hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px]"
            >
              <PlayCircleOutline style={{ fontSize: 40 }} />
              <span className="sr-only">{text({ th: "ดูวิดีโอห้องพัก", en: "Watch room video" })} — {text(data.roomTypeName)}</span>
            </a>
          </div>
        </div>
        <a
          href={lineLink}
          target="_blank"
          rel="noopener noreferrer"
          className="flex min-h-[48px] items-center justify-center gap-2 bg-cream px-4 py-3 text-olive hover:bg-secondary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px]"
        >
          <img src="LINE_Brand_icon.png" alt="" className="h-6 w-6" />
          {text({ th: "สอบถามห้องว่าง", en: "Check availability" })}
          <span className="sr-only"> — {text(data.roomTypeName)}</span>
        </a>
      </div>
    </div>
  )
}
